<script>
  import debounce from 'lodash/debounce'

  export default {
    name: 'BaseList',
    data () {
      return {
        sf: '',
        so: '',
        columns: [],
        actions: [],
        query: '',
        debouncedChangeSearch: debounce(this.changeSearch.bind(this), 500)
      }
    },
    methods: {
      fetchCurrentPage: async function () {},
      changeSearch () {
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, q: this.query, page: 1  } })
      },
      searchInput (val) {
        this.query = val
        this.debouncedChangeSearch.cancel()
        this.debouncedChangeSearch()
      }
    },
    watch: {
      '$route.query.q' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCurrentPage()
        }
      }
    }
  }
</script>
